// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let DateFns = require("date-fns");
let AgentInfo = require("../../common/Agent/AgentInfo.bs.js");
let HtmlDisplayer = require("../../common/Components/HtmlDisplayer.bs.js");
let MarkupHelpers = require("../../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyPage__Navbar = require("../../propertyPage/PropertyPage__Navbar.bs.js");
let Property__Components = require("../../../reason/clients/components/Property/Property__Components.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardFormRelay__Mutations = require("./PropertyWizardFormRelay__Mutations.bs.js");
let PropertyWizardRelay__Preview__Files = require("./PropertyWizardRelay__Preview__Files.bs.js");
let PropertyWizardRelay__Preview__Query = require("./PropertyWizardRelay__Preview__Query.bs.js");
let PropertyWizardRelay__Preview__Location = require("./PropertyWizardRelay__Preview__Location.bs.js");
let PropertyWizardRelay__Preview__Sidecard = require("./PropertyWizardRelay__Preview__Sidecard.bs.js");
let PropertyWizardRelay__Preview__ImageGrid = require("./PropertyWizardRelay__Preview__ImageGrid.bs.js");
let PropertyWizardRelay__Preview__ShowingsList = require("./PropertyWizardRelay__Preview__ShowingsList.bs.js");
let PropertyWizardRelayPreview_formState_graphql = require("../../../__generated__/PropertyWizardRelayPreview_formState_graphql.bs.js");
let PropertyWizardRelay__Preview__ListingDetails = require("./PropertyWizardRelay__Preview__ListingDetails.bs.js");
let PropertyWizardRelayPreview_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreview_localDraft_graphql.bs.js");
let PropertyWizardRelay__Preview__PropertyDetails = require("./PropertyWizardRelay__Preview__PropertyDetails.bs.js");
let PropertyWizardRelayPreview_serverDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreview_serverDraft_graphql.bs.js");
let PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
let PropertyWizardRelayPreview_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreview_displayHelpers_graphql.bs.js");
let PropertyWizardRelay__Preview__GlobalValidityIndicator = require("./PropertyWizardRelay__Preview__GlobalValidityIndicator.bs.js");
let PropertyWizardRelayPreviewDescription_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewDescription_localDraft_graphql.bs.js");
let PropertyWizardRelayPreviewBroadcastMessage_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewBroadcastMessage_localDraft_graphql.bs.js");
let PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers_graphql.bs.js");

let convertFragment = PropertyWizardRelayPreviewDescription_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewDescription_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewDescription_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewDescription_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewDescription_localDraft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayPreviewDescription_localDraft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayPreviewDescription_localDraft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Preview$Description(props) {
  let onEditForm = props.onEditForm;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewDescription_localDraft_graphql.node, convertFragment, props.draft);
  let isDescriptionValid = PropertyWizardFormRelay__Validators__Description.Description.useIsValid(draft.fragmentRefs);
  if (typeof isDescriptionValid === "object") {
    return JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
      text: `The description field is ` + isDescriptionValid.VAL,
      onClick: param => onEditForm("description")
    });
  } else {
    return JsxRuntime.jsx(HtmlDisplayer.make, {
      text: Stdlib_Option.getOr(draft.draftProperty.description, ""),
      proseStyle: "md"
    });
  }
}

let Description = {
  DraftFragment: DraftFragment,
  Validator: undefined,
  make: PropertyWizardRelay__Preview$Description
};

let convertFragment$1 = PropertyWizardRelayPreviewBroadcastMessage_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewBroadcastMessage_localDraft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewBroadcastMessage_localDraft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewBroadcastMessage_localDraft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewBroadcastMessage_localDraft_graphql.node, convertFragment$1, fRef);
}

let DraftFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Preview$BroadcastMessage(props) {
  let onEditForm = props.onEditForm;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewBroadcastMessage_localDraft_graphql.node, convertFragment$1, props.draft);
  let isSubjectValid = PropertyWizardFormRelay__Validators__Description.Subject.useIsValid(draft.fragmentRefs);
  let isMessageValid = PropertyWizardFormRelay__Validators__Description.Message.useIsValid(draft.fragmentRefs);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: typeof isSubjectValid === "object" ? JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
            text: `The headline field ` + isSubjectValid.VAL,
            onClick: param => onEditForm("description")
          }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(IconV5.make, {
                icon: "megaphone-alt",
                size: 18
              }),
              JsxRuntime.jsx("h2", {
                children: Stdlib_Option.getOr(draft.subject, ""),
                className: "text-2xl font-medium text-gray-800"
              })
            ]
          }),
        className: "flex flex-row space-x-2 items-center"
      }),
      JsxRuntime.jsx("div", {
        children: typeof isMessageValid === "object" ? JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
            text: `The message field ` + isMessageValid.VAL,
            onClick: param => onEditForm("description")
          }) : JsxRuntime.jsx(HtmlDisplayer.make, {
            text: Stdlib_Option.getOr(draft.message, ""),
            proseStyle: "md"
          })
      }),
      JsxRuntime.jsx("div", {
        children: "Broadcast on " + DateFns.format(new Date(), "M/d/yyyy"),
        className: "text-gray-500"
      })
    ],
    className: "space-y-4"
  });
}

let BroadcastMessage = {
  DraftFragment: DraftFragment$1,
  Validator: undefined,
  make: PropertyWizardRelay__Preview$BroadcastMessage
};

let convertFragment$2 = PropertyWizardRelayPreview_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreview_localDraft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreview_localDraft_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreview_localDraft_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreview_localDraft_graphql.node, convertFragment$2, fRef);
}

let DraftFragment_localDraftPropertyType_decode$1 = PropertyWizardRelayPreview_localDraft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString$1 = PropertyWizardRelayPreview_localDraft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment$2 = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode$1,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

let convertFragment$3 = PropertyWizardRelayPreview_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreview_displayHelpers_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreview_displayHelpers_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreview_displayHelpers_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreview_displayHelpers_graphql.node, convertFragment$3, fRef);
}

let DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

let convertFragment$4 = PropertyWizardRelayPreview_serverDraft_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreview_serverDraft_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreview_serverDraft_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreview_serverDraft_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreview_serverDraft_graphql.node, convertFragment$4, fRef);
}

let ServerDraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

let convertFragment$5 = PropertyWizardRelayPreview_formState_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreview_formState_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreview_formState_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreview_formState_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreview_formState_graphql.node, convertFragment$5, fRef);
}

let FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

let baseClasses = "border-t border-gray-200 ";

function PropertyWizardRelay__Preview$Divider(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "Base";
  let tmp;
  tmp = size === "Base" ? "my-8" : "my-12";
  return JsxRuntime.jsx("div", {
    className: baseClasses + tmp
  });
}

let Divider = {
  baseClasses: baseClasses,
  make: PropertyWizardRelay__Preview$Divider
};

let convertFragment$6 = PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers_graphql.Internal.convertFragment;

function waitForFragmentData$6(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers_graphql.node, convertFragment$6, fRef);
}

function use$6(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers_graphql.node, convertFragment$6, fRef);
}

function useOpt$6(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers_graphql.node, convertFragment$6);
}

function readResolverFragment$6(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers_graphql.node, convertFragment$6, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$6,
  waitForFragmentData: waitForFragmentData$6,
  use: use$6,
  useOpt: useOpt$6,
  readResolverFragment: readResolverFragment$6
};

function PropertyWizardRelay__Preview$MobileAgentInfoSection(props) {
  let match = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewMobileAgentInfoSection_previewHelpers_graphql.node, convertFragment$6, props.previewHelpers);
  let agent = match.agent;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: "Listing agent",
        className: "text-2xl text-gray-800 font-medium"
      }),
      JsxRuntime.jsx(AgentInfo.FromAgentOpt.make, {
        agent: agent !== undefined ? Primitive_option.some(agent.fragmentRefs) : undefined
      })
    ],
    className: "flex flex-col gap-4"
  });
}

let MobileAgentInfoSection = {
  Fragment: Fragment,
  make: PropertyWizardRelay__Preview$MobileAgentInfoSection
};

function PropertyWizardRelay__Preview(props) {
  let onEditForm = props.onEditForm;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreview_localDraft_graphql.node, convertFragment$2, props.draft);
  let fullLocalDraft = PropertyWizardFormRelay.LocalDraftFragment.use(draft.fragmentRefs);
  let data = PropertyWizardRelay__Preview__Query.Query.use({
    propertyData: PropertyWizardFormRelay.localDraftToDraftPropertyInput(fullLocalDraft)
  }, undefined, undefined, undefined);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreview_formState_graphql.node, convertFragment$5, props.formState);
  let displayHelpers = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreview_displayHelpers_graphql.node, convertFragment$3, data.propertyPreviewHelpers.fragmentRefs);
  let updateFormState = PropertyWizardFormRelay.FormState.useUpdater();
  let match = PropertyWizardFormRelay__Mutations.useMutationForSubmit(draft.fragmentRefs);
  let mutate = match[0];
  React.useEffect(() => {
    updateFormState(formState => {
      formState.stepKeyFactsTouched = true;
      formState.stepMlsTimingTouched = true;
      formState.stepDescriptionTouched = true;
      formState.stepShowingsTouched = true;
      formState.stepPhotosAndFilesTouched = true;
    });
  }, []);
  let imageCount = Stdlib_Option.getOr(displayHelpers.images, []).length;
  let fileCount = Stdlib_Option.getOr(displayHelpers.files, []).length;
  let match$1 = draft.draftProperty.propertyType;
  let tmp;
  tmp = match$1 === "FOR_SALE" ? "ForSale" : "Rental";
  let match$2 = displayHelpers.files;
  let match$3 = draft.draftProperty.propertyType;
  let tmp$1;
  tmp$1 = match$3 === "FOR_SALE" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(PropertyWizardRelay__Preview$Divider, {
          size: "Large"
        }),
        JsxRuntime.jsx("section", {
          children: JsxRuntime.jsx(PropertyWizardRelay__Preview__ShowingsList.make, {
            displayHelpers: displayHelpers.fragmentRefs,
            draft: draft.fragmentRefs,
            onEditForm: onEditForm
          })
        })
      ]
    }) : null;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator.make, {
        formState: formState.fragmentRefs,
        draft: draft.fragmentRefs,
        onEditForm: onEditForm,
        onSubmit: () => {
          mutate();
        },
        currentStep: props.currentStep,
        isSubmittingForm: match[1]
      }),
      JsxRuntime.jsx(MarkupHelpers.Container.make, {
        children: JsxRuntime.jsx(PropertyPage__Navbar.Navbar.make, {
          hasImages: imageCount > 0,
          hasFiles: fileCount > 0,
          propertyType: tmp,
          shouldShowPropertyDetails: true
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(PropertyWizardRelay__Preview__ImageGrid.make, {
            displayHelpers: displayHelpers.fragmentRefs
          }),
          JsxRuntime.jsxs(MarkupHelpers.Container.make, {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(PropertyWizardRelay__Preview__PropertyDetails.make, {
                        draft: draft.fragmentRefs,
                        formState: formState.fragmentRefs,
                        displayHelpers: displayHelpers.fragmentRefs,
                        onEditForm: onEditForm
                      }),
                      JsxRuntime.jsx(PropertyWizardRelay__Preview$Divider, {}),
                      JsxRuntime.jsx("section", {
                        children: JsxRuntime.jsx(PropertyWizardRelay__Preview$BroadcastMessage, {
                          draft: draft.fragmentRefs,
                          onEditForm: onEditForm
                        })
                      }),
                      JsxRuntime.jsx(PropertyWizardRelay__Preview$Divider, {}),
                      JsxRuntime.jsx("section", {
                        children: JsxRuntime.jsx(PropertyWizardRelay__Preview$Description, {
                          draft: draft.fragmentRefs,
                          onEditForm: onEditForm
                        })
                      }),
                      JsxRuntime.jsx(PropertyWizardRelay__Preview$Divider, {
                        size: "Large"
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("section", {
                            children: JsxRuntime.jsx(PropertyWizardRelay__Preview__ListingDetails.make, {
                              draft: draft.fragmentRefs,
                              formState: formState.fragmentRefs,
                              previewHelpers: displayHelpers.fragmentRefs,
                              onEditForm: onEditForm
                            })
                          }),
                          JsxRuntime.jsx("section", {
                            children: JsxRuntime.jsx(PropertyWizardRelay__Preview$MobileAgentInfoSection, {
                              previewHelpers: displayHelpers.fragmentRefs
                            }),
                            className: "block md:hidden"
                          })
                        ],
                        className: "flex flex-col gap-12"
                      })
                    ],
                    className: ""
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(PropertyWizardRelay__Preview__Sidecard.make, {
                        draft: draft.fragmentRefs,
                        formState: formState.fragmentRefs,
                        displayHelpers: displayHelpers.fragmentRefs,
                        onEditForm: onEditForm
                      }),
                      className: "max-w-sm"
                    }),
                    className: "md:flex w-full justify-end hidden"
                  })
                ],
                className: "grid gap-16 grid-cols-1 md:grid-cols-[2fr_minmax(280px,1fr)]"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  match$2 !== undefined && match$2.length !== 0 ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsx(PropertyWizardRelay__Preview$Divider, {
                          size: "Large"
                        }),
                        JsxRuntime.jsx("section", {
                          children: JsxRuntime.jsx(PropertyWizardRelay__Preview__Files.make, {
                            displayHelpers: displayHelpers.fragmentRefs
                          })
                        })
                      ]
                    }) : null,
                  tmp$1,
                  JsxRuntime.jsx(PropertyWizardRelay__Preview$Divider, {
                    size: "Large"
                  }),
                  JsxRuntime.jsx("section", {
                    children: JsxRuntime.jsx(PropertyWizardRelay__Preview__Location.make, {
                      displayHelpers: displayHelpers.fragmentRefs,
                      draft: draft.fragmentRefs
                    })
                  })
                ]
              })
            ]
          })
        ],
        className: "space-y-8 pb-8"
      })
    ]
  });
}

let FormState;

let Validators;

let View;

let MissingFieldMarker;

let GlobalValidityIndicator;

let ImageGrid;

let PropertyDetails;

let Sidecard;

let ShowingsList;

let ListingDetails;

let LocationMap;

let Files;

let Navbar;

let Container;

let Query;

let make = PropertyWizardRelay__Preview;

exports.FormState = FormState;
exports.Validators = Validators;
exports.View = View;
exports.MissingFieldMarker = MissingFieldMarker;
exports.GlobalValidityIndicator = GlobalValidityIndicator;
exports.ImageGrid = ImageGrid;
exports.PropertyDetails = PropertyDetails;
exports.Sidecard = Sidecard;
exports.ShowingsList = ShowingsList;
exports.ListingDetails = ListingDetails;
exports.LocationMap = LocationMap;
exports.Files = Files;
exports.Navbar = Navbar;
exports.Container = Container;
exports.Description = Description;
exports.BroadcastMessage = BroadcastMessage;
exports.DraftFragment = DraftFragment$2;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.ServerDraftFragment = ServerDraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.Divider = Divider;
exports.MobileAgentInfoSection = MobileAgentInfoSection;
exports.Query = Query;
exports.make = make;
/* react Not a pure module */
